import { useState } from "react";
import { CalendarClock } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const joinIt = (arr) => (arr.length <= 1 ? arr.join("") : `${arr.slice(0, -1).join(", ")} e ${arr[arr.length - 1]}`);

export function CatchupDialog({ calendar, onDone }) {
  const [busy, setBusy] = useState(null);
  const open = !!calendar?.needs_choice;
  const labels = (calendar?.pending_days || []).map((n) => calendar.days[n - 1].label.toLowerCase());
  const choose = async (action) => {
    setBusy(action);
    try {
      await api.post("/path/catchup", { action });
      await onDone();
    } finally {
      setBusy(null);
    }
  };
  return (
    <Dialog open={open}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-[400px] rounded-3xl border-[#27272A] bg-[#09090B] text-[#FAF9F6] [&>button]:hidden" data-testid="catchup-dialog">
        <DialogHeader>
          <CalendarClock size={28} className="text-[#D4AF37]" />
          <DialogTitle className="font-serif-el pt-2 text-2xl">Riprendiamo il tuo percorso</DialogTitle>
          <DialogDescription className="text-base leading-relaxed text-[#D4D4D8]">
            Hai lasciato in sospeso {labels.length === 1 ? "il giorno" : "i giorni"} <b className="text-[#E5C158]" data-testid="catchup-days">{joinIt(labels)}</b>. Nessun problema: vuoi recuperare o ripartire da oggi?
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2 space-y-2.5">
          <button onClick={() => choose("recover")} disabled={!!busy} data-testid="catchup-recover-button" className="btn-gold w-full rounded-full px-6 py-3.5 text-sm font-semibold uppercase tracking-wide disabled:opacity-50">
            {busy === "recover" ? "Un momento…" : "Recupera, poi passa a oggi"}
          </button>
          <button onClick={() => choose("skip")} disabled={!!busy} data-testid="catchup-skip-button" className="w-full rounded-full border border-[#3F3F46] px-6 py-3.5 text-sm font-semibold text-[#E4E4E7] disabled:opacity-50">
            {busy === "skip" ? "Un momento…" : "Salta e vai a oggi"}
          </button>
          <p className="pt-1 text-center text-sm text-[#B4B4BC]">I giorni saltati restano nel Percorso: puoi farli quando vuoi.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
